// @flow

/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/

/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Brian Haak.
 * @license MIT license
 * @link https://codepen.io/avesus/pen/wgQmaV?editors=0012
 **/
const lut = Array(256)
  .fill()
  .map((_, i) => (i < 16 ? '0' : '') + i.toString(16))

const formatUuid = ({d0, d1, d2, d3}) => `${lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff]}-${lut[d1 & 0xff]}${lut[
  d1 >> 8 & 0xff
]}-${lut[d1 >> 16 & 0x0f | 0x40]}${lut[d1 >> 24 & 0xff]}-${lut[d2 & 0x3f | 0x80]}${lut[
  d2 >> 8 & 0xff
]}-${lut[d2 >> 16 & 0xff]}${lut[d2 >> 24 & 0xff]}${lut[d3 & 0xff]}${lut[d3 >> 8 & 0xff]}${lut[
  d3 >> 16 & 0xff
]}${lut[d3 >> 24 & 0xff]}`

const getRandomValuesFunc =
  self.crypto && self.crypto.getRandomValues ?
    () => {
      const dvals = new Uint32Array(4)
      self.crypto.getRandomValues(dvals)
      return {
        d0: dvals[0],
        d1: dvals[1],
        d2: dvals[2],
        d3: dvals[3],
      }
    } :
    () => ({
      d0: Math.random() * 0x100000000 >>> 0,
      d1: Math.random() * 0x100000000 >>> 0,
      d2: Math.random() * 0x100000000 >>> 0,
      d3: Math.random() * 0x100000000 >>> 0,
    })

export default () => formatUuid(getRandomValuesFunc())
